class productCardVariants extends HTMLElement {
  constructor() {
    super();

    // Options
    this.options = {};

    // Get options from element data and combine with this.options
    if (this?.dataset?.options) {
      const dataOptions = parseJson(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    // Selectors
    this.card = this.closest('[data-product-card]');

    // Check if every thing exists
    if (!this.card || !this.options.variant || !this.options.handle) {
      return;
    }

    // Cache data
    this.data = [
      {
        id: parseInt(this.options.variant),
        html: this.card.innerHTML,
      },
    ];

    // On mouse over color dots
    this.querySelectorAll('[data-option]').forEach((button) => {
      button.addEventListener('click', (event) => {
        this.setVariant(event);
      });
    });
  }

  // Update selected variant
  setVariant(event) {
    // Set current variant based on color
    this.option = event.currentTarget.dataset.option;
    this.value = event.currentTarget.dataset.value;
    let initialVariant;
    this.currentVariant = this.getVariantData().find((variant) => {
      if (variant[this.option] == this.value) {
        // Set initialVariant in case there are no available matching variants
        if (!initialVariant) {
          initialVariant = variant;
        }

        if (variant.available) {
          return true;
        }
      }

      return false;
    });

    // If there isn't a matching available variant use the initialVariant
    if (!this.currentVariant && initialVariant) {
      this.currentVariant = initialVariant;
    }

    if (!this.currentVariant) {
      return;
    }

    // Update UI for dots
    this.querySelectorAll('[data-option]').forEach((button) => {
      button.classList.remove('active');
    });
    event.currentTarget.classList.add('active');

    // Update product images
    this.currentVariantId = this.currentVariant.id;
    this.updateProductCard(this.currentVariantId);
  }

  // Update product card images
  async updateProductCard(id) {
    // Get data
    const html = await this.getProductVariants(id);

    // Continue only if current variant not is changed
    if (this.currentVariantId != id) {
      return;
    }

    // Append data
    this.card.innerHTML = html;
  }

  // Get variant images from cache or fetch
  async getProductVariants(id) {
    // Check for cached data
    const item = this.data.find((item) => item.id == parseInt(id));

    // Fetch data if not in cache
    if (!item) {
      let data = await fetch(
        `/products/${this.options.handle}?view=card-variants&variant=${id}`,
        this.fetchConfig()
      );

      data = await data.text();
      let html = new DOMParser()
        .parseFromString(data, 'text/html')
        .querySelector('[data-product-card-variants]').innerHTML;

      // Cache fetch
      this.data.push({
        id: id,
        html: html,
      });

      return html;
    }

    return item.html;
  }

  // Get variant data json
  getVariantData() {
    this.variantData =
      this.variantData || parseJson(this.querySelector('[data-variant-json]').textContent);

    return this.variantData;
  }

  // Fetch config
  fetchConfig() {
    return {
      method: 'GET',
      headers: { 'Content-Type': 'text/html' },
    };
  }
}

if (!customElements.get('product-card-variants')) {
  customElements.define('product-card-variants', productCardVariants);
}
